import { SystemMail, SystemMailWithoutBody } from "../model/SystemMail";
import { fetchWithToken } from "./fetchWithToken";

const getBaseUrl = (customerId: string) => {
    switch (process.env.NODE_ENV) {
        case "production":
            return `/api/system/customers/${customerId}/system-mails`;
        case "development":
            return `http://localhost:5000/api/system/customers/${customerId}/system-mails`;
        default:
            return `/api/system/customers/${customerId}/system-mails`;
    }
};

export async function getCustomerSystemMails(customerId: string): Promise<SystemMailWithoutBody[]> {
    const response = await fetchWithToken(getBaseUrl(customerId), { method: "GET" });
    if (!response.ok) throw new Error("Error while loading system mail templates");
    return response.json();
}

export async function getSystemMailById(
    templateId: string,
    customerId: string
): Promise<SystemMail> {
    const response = await fetchWithToken(getBaseUrl(customerId) + `/${templateId}`, {
        method: "GET",
    });
    if (!response.ok) throw new Error("Error loading system mail template");
    return response.json();
}

export async function createSystemMail(
    template: SystemMail,
    customerId: string
): Promise<SystemMail> {
    const response = await fetchWithToken(getBaseUrl(customerId), {
        method: "POST",
        body: JSON.stringify(template),
        headers: { "Content-Type": "application/json" },
    });
    if (!response.ok) throw new Error("Error creating system mail template");
    return response.json();
}

export async function updateSystemMail(
    template: SystemMail,
    templateId: string,
    customerId: string
): Promise<SystemMail> {
    const response = await fetchWithToken(getBaseUrl(customerId) + `/${templateId}`, {
        method: "PUT",
        body: JSON.stringify(template),
        headers: { "Content-Type": "application/json" },
    });
    if (!response.ok) throw new Error("Error updating system mail template");
    return response.json();
}

export async function deleteSystemMail(templateId: string, customerId: string): Promise<void> {
    const response = await fetchWithToken(getBaseUrl(customerId) + `/${templateId}`, {
        method: "DELETE",
    });
    if (!response.ok) throw new Error("Error deleting system mail template");
}

function getSystemApiBaseUrl(): string {
    switch (process.env.NODE_ENV) {
        case "production":
            return "/api";
        case "development":
            return "http://localhost:5000/api";
        default:
            return "/api";
    }
}

export async function copySystemMailsToCustomer(
    templateIds: string[],
    targetCustomerId: string
): Promise<Response> {
    const url = `${getSystemApiBaseUrl()}/system/system-mails/clone?targetCustomer=${encodeURIComponent(targetCustomerId)}`;
    const response = await fetchWithToken(url, {
        method: "POST",
        body: JSON.stringify(templateIds),
        headers: { "Content-Type": "application/json" },
    });
    return response;
}
